export const DOMAINS = [
    ".al",    // Albania
    ".ba",    // Bosnia and Herzegovina
    ".bg",    // Bulgaria
    ".cy",    // Cyprus
    ".dk",    // Denmark
    ".ie",    // Ireland
    ".ee",    // Estonia
    ".at",    // Austria
    ".cz",    // Czech Republic
    ".fi",    // Finland
    ".fr",    // France
    ".ge",    // Georgia
    ".de",    // Germany
    ".gr",    // Greece
    ".hr",    // Croatia
    ".hu",    // Hungary
    ".is",    // Iceland
    ".it",    // Italy
    ".lv",    // Latvia
    ".by",    // Belarus
    ".lt",    // Lithuania
    ".sk",    // Slovakia
    ".li",    // Liechtenstein
    ".mk",    // North Macedonia
    ".mt",    // Malta
    ".be",    // Belgium
    ".fo",    // Faroe Islands
    ".ad",    // Andorra
    ".lu",    // Luxembourg
    ".mc",    // Monaco
    ".me",    // Montenegro
    ".nl",    // Netherlands
    ".no",    // Norway
    ".pl",    // Poland
    ".pt",    // Portugal
    ".ro",    // Romania
    ".md",    // Republic of Moldova
    ".si",    // Slovenia
    ".es",    // Spain
    ".se",    // Sweden
    ".ch",    // Switzerland
    ".tr",    // Turkey
    ".uk",    // United Kingdom
    ".ua",    // Ukraine
    ".sm",    // San Marino
    ".rs",    // Serbia
    ".va",    // Holy See (Vatican City)
    ".ru",    // Russia
]

export const COUNTRY_INDEX_TO_DOMAIN_INDEX = [
    [0], [1], [2], [3], [4], [5], [6], [7], [8], [9], [10], [11], [12], [13], [14], [15], [16], [17], 
    [18], [19], [20], [21], [22], [23], [24], [25], [26], [27], [28], [29], [30], [31], [32], [33], 
    [34], [35], [36], [37], [38], [39], [40], [41], [42], [43], [44], [45], [46], [47]
];
